/* eslint-disable */
import { createRouter, createWebHashHistory } from "vue-router";
import { setCurrentUser } from "@/session";
import cookie from "@/utilities/cookie.js";
import { useBrandStore } from "@/stores/brand.js";
import { useCategorization } from "@/stores/categorization.js";
import { usePlanLimitStore } from "@/stores/planLimit.js";

// General
const DeactivatedWarning = () =>
  import("@/pages/General/DeactivatedWarning.vue");

// Dashboard
const Dashboard = () => import("@/pages/Dashboard/Index.vue");
const Debug = () => import("@/pages/Dashboard/Debug.vue");

// Login screens
const Login = () => import("@/pages/SignIn/Index.vue");
const LinkBrand = () => import("@/pages/SignIn/LinkBrand.vue");
const AuthEmail = () => import("@/pages/SignIn/AuthEmail.vue");
const ResetPassword = () => import("@/pages/SignIn/ResetPassword.vue");
const ResetPasswordExpired = () =>
  import("@/pages/CreateAccount/ResetPasswordExpired.vue");
const VerificationCode = () => import("@/pages/SignIn/VerificationCode.vue");
const VerifyEmail = () => import("@/pages/SignIn/VerifyEmail.vue");
const InvalidConfirmation = () =>
  import("@/pages/SignIn/InvalidConfirmation.vue");
const ChooseBrand = () => import("@/pages/SignIn/ChooseBrand.vue");
const CreateAccount = () => import("@/pages/CreateAccount/Index.vue");

// Sidebar > Marketing
const MarketingButton = () => import("@/pages/Marketing/Index.vue");
const AcquisitionPage = () =>
  import("@/pages/Marketing/AcquisitionPage/Index.vue");
const MessageBroadcast = () =>
  import("@/pages/Marketing/BroadcastMessage/Index.vue");
const MessageBroadcastReport = () =>
  import(
    "@/pages/Analytics/MarketingAnalytics/MessageBroadcast/Report/Report.vue"
  );
const AutomationPage = () =>
  import("@/pages/Marketing/AutomatedMessage/Index.vue");
const AutomationReport = () =>
  import("@/pages/Analytics/MarketingAnalytics/MessageAutomation/Report.vue");
const SocialMedia = () => import("@/pages/Marketing/SocialMedia/Index.vue");
const LandingPage = () => import("@/pages/Marketing/LandingPage/Index.vue");
const Giveaway = () => import("@/pages/Marketing/Giveaway/Index.vue");
const WhatsappTemplateV2 = () =>
  import("@/pages/Marketing/WhatsappTemplateV2/Index.vue");
const MessagesonHold = () =>
  import("@/pages/Marketing/MessagesonHold/Index.vue");
const InstagramAutoDM = () =>
  import("@/pages/Marketing/InstagramAutoDM/Index.vue");
// Sidebar > Members
const MembersPage = () => import("@/pages/Members/Index.vue");

// Sidebar > Reports
const ReportsAccess = () => import("@/pages/Reports/Index.vue");

const MonthlyReports = () => import("@/pages/Reports/Monthly/Index.vue");

// Sidebar > Analytics
const MarketingAnalytics = () =>
  import("@/pages/Analytics/MarketingAnalytics/Index.vue");
const LandingPageAnalytics = () =>
  import("@/pages/Analytics/LandingPageAnalytics/Index.vue");
const MemberAnalytics = () => import("@/pages/Members/Analytics/Index.vue");
const AutoRecharge = () =>
  import("@/pages/Billing/RechargeSMSCredit/AutoRecharge/Index.vue");

// Sidebar > Loyalty Program
const SpendingPointConversion = () =>
  import("@/pages/LoyaltyProgram/EarningPoints/Index.vue");
const IntegrationPage = () =>
  import("@/pages/LoyaltyProgram/RedeemingPoints/Index.vue");
const VipCircles = () => import("@/pages/LoyaltyProgram/VipCircles/Index.vue");
const MemberPortal = () =>
  import("@/pages/LoyaltyProgram/MemberPortal/MemberPortal.vue");
const StampPage = () => import("@/pages/LoyaltyProgram/Stamp/Index.vue");
const WalletPage = () => import("@/pages/Wallets/Index.vue");

// Sidebar > Billing
// const AddSMSCredits = () =>
// import("@/pages/Billing/RechargeSMSCredit/AddSMSCredit/Index.vue");
const CreditHistory = () =>
  import("@/pages/Billing/RechargeSMSCredit/CreditHistory/Index.vue");

const InvoicePayments = () =>
  import("@/pages/Billing/Invoices&Payments/Index.vue");

// Menu > Account > Settings
const UserPermissionPage = () =>
  import("@/pages/AccountManagement/Settings/Permissions/Index.vue");
const AccountUserInfoPage = () =>
  import("@/pages/AccountManagement/Settings/UserInfo/Index.vue");
const LanguagePage = () =>
  import("@/pages/AccountManagement/Settings/Languages/Index.vue");

// Menu > Account > Store
const StoreSecurity = () =>
  import("@/pages/AccountManagement/Store/StoreSecurity/Index.vue");
const SecurityLogs = () =>
  import("@/pages/AccountManagement/Store/SecurityLogs/Index.vue");
const ResetStore = () =>
  import("@/pages/AccountManagement/Store/AddStore/Index.vue");

// Menu > Account > Integrations
const LoyaltyProgram = () =>
  import("@/pages/AccountManagement/Integrations/LoyaltyProgram/Index.vue");
const MarketingV2 = () =>
  import("@/pages/AccountManagement/Integrations/MarketingV2/Index.vue");

// Menu > Account > Other
const Onboarding = () =>
  import("@/pages/AccountManagement/UserOnboarding/Index.vue");
const GetStarted = () =>
  import("@/pages/AccountManagement/GetStarted/Index.vue");
const MarketingSetting = () =>
  import("@/pages/AccountManagement/MarketingSetting/Index.vue");
const Logout = () => import("@/pages/AccountManagement/Logout/Index.vue");
const Referral = () => import("@/pages/UserReferrals/Index.vue");

// Miscellaneous
const ComingSoon = () => import("@/pages/reusables/ComingSoon/Index.vue");
const DemoIndex = () =>
  import("@/pages/Billing/RechargeSMSCredit/DemoIndex/Index.vue");
const ContestPage = () => import("@/pages/Marketing/ContestPage/Index.vue"); // No idea

const InstaAnalytics = () => import("@/pages/Insta/Index.vue");

//Google reviews

const GoogleReviews = () => import("@/pages/Marketing/GoogleReviews/Index.vue");
const GoogleReviewManager = () => import("@/pages/ReviewRecap/Index.vue");

//Membership Page
const Membership = () => import("@/pages/Membership/Index.vue");
const SpinTheWheel = () => import("@/pages/Marketing/SpinTheWheel/Index.vue");

//Account Credits Page
const AccountCredits = () => import("@/pages/Billing/AccountCredits/Index.vue");

//Categorization Products Page
const CategorizationPage = () => import("@/pages/Categorization/Index.vue");

//Aicco related
const Aicco = () => import("@/pages/Aicco/Index.vue");

//Meta Ads Tracker
const MetaAdsTracker = () =>
  import("@/pages/Marketing/MetaAdsTracker/Index.vue");

// Analytics
const MonthlyReport = () =>
  import("@/pages/Analytics/Reports/MonthlyReportTemplate.vue");
const RetentionReport = () =>
  import("@/pages/Analytics/Reports/RetentionReportTemplate.vue");

const WsOmnibox = () =>
  import("@/pages/Dashboard/Content/Widgets/WsOmnibox/Index.vue");

const routes = [
  {
    path: "/",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
    },
  },
  {
    path: "/brand-deactivated",
    name: "DeactivatedWarning",
    component: DeactivatedWarning,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/marketing-page",
    name: "MarketingButton",
    component: MarketingButton,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
    },
  },
  {
    path: "/debug",
    name: "Debug",
    component: Debug,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/point-settings",
    name: "STPC",
    component: SpendingPointConversion,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
      requiresPoints: true, // This is a custom meta field to check if the user has access to Points settings
      basicPlanBlockedTabs: ["Multipliers", "Reminders"],
    },
  },
  {
    path: "/onboarding",
    name: "Location",
    component: Onboarding,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/analytics/members",
    name: "MemberAnalytics",
    component: MemberAnalytics,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
    },
  },
  {
    path: "/report/monthly-report/:year/:month",
    name: "MonthlyReport",
    component: MonthlyReport,
    props: true,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
    },
  },
  {
    path: "/analytics/retention-report/:year/:month/:store?",
    name: "RetentionReport",
    component: RetentionReport,
    props: true,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
    },
  },
  {
    path: "/integration-page",
    name: "IntegrationPage",
    component: IntegrationPage,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
      requiresNotRestricted: true,
    },
  },
  {
    path: "/stamp-settings",
    name: "StampPage",
    component: StampPage,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
      requiresStamp: true, // This is a custom meta field to check if the user has access to Stamp settings
    },
  },
  {
    path: "/invite/:token",
    name: "InviteToken",
    component: CreateAccount,
    props: true,
  },
  {
    path: "/invite",
    name: "Invite",
    component: CreateAccount,
    props: true,
  },
  // {
  //   path: "/create-account",
  //   name: "CreateAccount",
  //   component: CreateAccount,
  // },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/link-brand/:brand_name/:brand_id/:token",
    name: "LinkBrand",
    component: LinkBrand,
    props: true,
  },
  {
    path: "/auth-reset",
    name: "AuthEmail",
    component: AuthEmail,
  },
  {
    path: "/reset-password/:token",
    name: "ResetPassword",
    component: ResetPassword,
    props($route) {
      return {
        token: $route.params.token,
      };
    },
  },
  {
    path: "/reset-password-expired",
    name: "ResetPasswordExpired",
    component: ResetPasswordExpired,
  },
  {
    path: "/verification-code/:email/:code",
    name: "VerificationCode",
    component: VerificationCode,
    //below is used for demo purposes only, need to remove this before production
    props($route) {
      return {
        email: $route.params.email,
        code: $route.params.code,
      };
    },
  },
  {
    path: "/verify-email/:email",
    name: "VerifyEmail",
    component: VerifyEmail,
    props($route) {
      return {
        email: $route.params.email,
      };
    },
  },
  {
    path: "/invalid-confirmation/:email",
    name: "InvalidConfirmation",
    component: InvalidConfirmation,
    props($route) {
      return {
        email: $route.params.email,
      };
    },
  },
  {
    path: "/choose-brand",
    name: "ChooseBrand",
    component: ChooseBrand,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/account/permissions",
    name: "UserPermissionPage",
    component: UserPermissionPage,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
    },
  },
  {
    path: "/account/user-info",
    name: "Account User Info Page",
    component: AccountUserInfoPage,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
    },
  },
  {
    path: "/account/store-security",
    name: "Security Code",
    component: StoreSecurity,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
    },
  },
  {
    path: "/account/security-logs",
    name: "Security Logs",
    component: SecurityLogs,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
    },
  },
  {
    path: "/account/add-store",
    name: "Add Store",
    component: ResetStore,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
    },
  },
  {
    path: "/integration/marketing",
    name: "Marketing",
    component: MarketingV2,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
    },
  },
  {
    path: "/integration/marketing-v2",
    name: "MarketingV2",
    component: MarketingV2,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
    },
  },
  {
    path: "/integration/loyalty-program",
    name: "Loyalty Program",
    component: LoyaltyProgram,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
    },
  },
  {
    path: "/account/languages",
    name: "Languages",
    component: LanguagePage,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
    },
  },
  {
    path: "/get-started",
    name: "Get Started",
    component: GetStarted,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
    },
  },
  {
    path: "/broadcast-message",
    name: "BroadcastMessage",
    component: MessageBroadcast,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
      requiresNotRestricted: true,
    },
  },
  {
    path: "/email-broadcast",
    name: "EmailBroadcast",
    component: MessageBroadcast,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
      requiresBetaTester: true,
      requiresConfigEmailVerification: true,
      requiresNotBasicPlan: true,
    },
  },
  {
    path: "/broadcast-message/reports/:specification/:objectId",
    name: "BroadcastMessageReport",
    component: MessageBroadcastReport,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
    },
    props: true,
  },

  {
    path: "/automation/reports/:campaignId",
    name: "AutomationReport",
    component: AutomationReport,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
    },
    props: true,
  },
  {
    path: "/marketing-setting",
    name: "Marketing Setting",
    component: MarketingSetting,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
    },
  },
  {
    path: "/automated-message",
    name: "Automation Page",
    component: AutomationPage,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
      requiresNotRestricted: true,
      requiresNotBasicPlan: true,
    },
  },
  {
    path: "/instagram-automation",
    name: "Instagram Auto DM",
    component: InstagramAutoDM,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
      requiresNotBasicPlan: true,
    },
  },
  {
    path: "/acquisition-page",
    name: "AcquisitionPage",
    component: AcquisitionPage,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
      requiresNotRestricted: true,
      requiresNotBasicPlan: true,
    },
  },
  {
    path: "/social-media",
    name: "Social Media",
    component: SocialMedia,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
    },
  },
  {
    path: "/landing-page",
    name: "Landing Page",
    component: LandingPage,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
    },
  },
  {
    path: "/analytics/marketing/landing-page",
    name: "Landing Page Analytics",
    component: LandingPageAnalytics,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
    },
  },
  {
    path: "/contest-page",
    name: "ContestPage",
    component: ContestPage,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
    },
  },
  {
    path: "/logout",
    name: "Logout",
    component: Logout,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/referral",
    name: "Referral",
    component: Referral,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
    },
  },
  // {
  //   path: "/sms-recharge",
  //   name: "AddSMSCredits",
  //   component: AddSMSCredits,
  //   meta: {
  //     requiresAuth: true,
  //     requiresBrand: true,
  //   },
  // },
  {
    path: "/auto-recharge",
    name: "AutoRecharge",
    component: AutoRecharge,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
    },
  },
  {
    path: "/billing/:sessionId?/",
    name: "InvoicePayments",
    component: InvoicePayments,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
    },
    props($route) {
      return {
        sessionId: $route.params.sessionId || null,
      };
    },
  },
  {
    path: "/members",
    name: "MembersPage",
    component: MembersPage,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
    },
  },
  {
    path: "/report",
    name: "ReportsPage",
    component: ReportsAccess,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
    },
  },
  {
    path: "/analytics/marketing",
    name: "Marketing Analytics",
    component: MarketingAnalytics,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
    },
  },
  {
    path: "/analytics/members",
    name: "Member Analytics",
    component: MemberAnalytics,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
    },
  },
  {
    path: "/vip-circles",
    name: "VIP Circles",
    component: VipCircles,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
    },
  },
  {
    path: "/analytics/members",
    name: "Member Analytics",
    component: MemberAnalytics,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
    },
  },
  {
    path: "/coming-soon",
    name: "Coming Soon",
    component: ComingSoon,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
    },
  },
  // Whatsapp Template
  {
    path: "/whatsapp-templates",
    name: "Whatsapp Templates",
    component: WhatsappTemplateV2,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
      requiresBusinessPlan: true,
    },
  },
  // messages onhold
  {
    path: "/messages-onhold",
    name: "Messages On Hold",
    component: MessagesonHold,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
      requiresNotBasicPlan: true,
    },
  },
  {
    path: "/google-reviews",
    name: "Google Reviews",
    component: GoogleReviews,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
      requiresNotRestricted: true,
      requiresNotBasicPlan: true,
    },
  },
  {
    path: "/google-review-manager",
    name: "Google Review Manager",
    component: GoogleReviewManager,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
      requiresNotBasicPlan: true,
    },
  },
  {
    path: "/membership-program",
    name: "Membership",
    component: Membership,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
      requiresNotRestricted: true,
    },
  },
  // {
  //   path: "/giveaway",
  //   name: "Giveaway",
  //   component: Giveaway,
  //   meta: {
  //     requiresAuth: true,
  //     requiresBrand: true,
  //   },
  // },
  {
    path: "/analytics/instagram",
    name: "Instagram",
    component: InstaAnalytics,
  },
  {
    path: "/spin-the-wheel",
    name: "SpinTheWheel",
    component: SpinTheWheel,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
      requiresNotRestricted: true,
      requiresNotBasicPlan: true,
    },
  },
  {
    path: "/member-portal",
    name: "MemberPortal",
    component: MemberPortal,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
    },
  },
  {
    path: "/digital-wallets",
    name: "WalletPage",
    component: WalletPage,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
      requiresNotBasicPlan: true,
    },
  },
  {
    path: "/account-credits/:sessionId?/:successfulRecharge?",
    name: "Account Credits",
    component: AccountCredits,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
    },
  },
  {
    path: "/credit-history",
    name: "CreditHistory",
    component: CreditHistory,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
    },
  },
  {
    path: "/meta-ads-tracker",
    name: "MetaAdsTracker",
    component: MetaAdsTracker,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
      requiresNotBasicPlan: true,
    },
  },
  {
    path: "/categorization",
    name: "CategorizationPage",
    component: CategorizationPage,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
    },
  },
  {
    path: "/aicco",
    name: "Aicco",
    component: Aicco,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
    },
  },
  {
    path: "/omnibox",
    name: "WsOmnibox",
    component: WsOmnibox,
    meta: {
      requiresAuth: true,
      requiresBrand: true,
      requiresNotBasicPlan: true,
    },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        top: 0,
      };
    }
  },
});

router.beforeEach(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    const result = await setCurrentUser();
    if (result === false) {
      next({ name: "Login" });
    } else {
      if (to.matched.some((record) => record.meta.requiresBrand)) {
        if (cookie.getSecureCookie("mulah_br") === false) {
          next({ name: "ChooseBrand" });
        } else if (localStorage.getItem("brandDeactivated") == "true") {
          next({ name: "DeactivatedWarning" });
        } else {
          next();
        }
      } else {
        next();
      }
    }
  } else {
    next();
  }
});

router.beforeResolve(async (to, from, next) => {
  const store = useBrandStore();
  const categoryStore = useCategorization();
  const planStore = usePlanLimitStore();

  if (to.meta.requiresBrand) {
    console.log("in here before resolve");
    await store.getBrand();
    await planStore.getPlanLimit();
    await categoryStore.getOpusData();
    if (
      to.matched.some((record) => record.meta.requiresNotRestricted) &&
      store.isRestricted
    ) {
      next({ name: "Dashboard" });
      return;
    }
    if (to.matched.some((record) => record.meta.requiresNotBasicPlan)) {
      if (planStore.isBasicPlan) {
        next({ name: "Dashboard" });
        return;
      }
    }
    if (to.matched.some((record) => record.meta.requiresBusinessPlan)) {
      if (!planStore.isBusinessPlan) {
        next({ name: "Dashboard" });
        return;
      }
    }
    if (planStore.isBasicPlan && to.meta.basicPlanBlockedTabs) {
      if (to.meta.basicPlanBlockedTabs.includes(to.query.tab)) {
        const { tab, ...query } = to.query;
        next({ path: to.path, query });
        return;
      }
    }
    if (to.matched.some((record) => record.meta.requiresStamp)) {
      if (!store.isPointsCollection) {
        next();
      } else {
        next({ name: "STPC" });
      }
      return;
    } else if (to.matched.some((record) => record.meta.requiresPoints)) {
      if (store.isPointsCollection) {
        next();
      } else {
        next({ name: "StampPage" });
      }
      return;
    } else if (to.matched.some((record) => record.meta.requiresBetaTester)) {
      if (!store.isBetaTester) {
        next({ name: "Dashboard" });
        return;
      }
      if (
        to.matched.some(
          (record) => record.meta.requiresConfigEmailVerification
        ) &&
        store.isEmailBroadcastDisabled
      ) {
        next({ name: "Dashboard" });
        return;
      }
      next();
      return;
    }
  }
  next();
});

router.onError((error) => {
  if (/loading chunk \d* failed./i.test(error.message) && navigator.onLine) {
    window.location.reload();
  }
});

export default router;
